/**
 * Atomically delete elements.
 *
 * These function forward to the MST actions.
 */
import type { IMetaModel } from '../../../../stores/model/metamodel';
import type { IObjectType } from '../../../../stores/model/metamodel/object_type';
import type { IEventType } from '../../../../stores/model/metamodel/event_type';
import type { IMethod } from '../../../../stores/model/metamodel/method';
import type { IDependency } from '../../../../stores/model/metamodel/dependency';
import type { IInheritance } from '../../../../stores/model/metamodel/inheritance';
import type { IFSM } from '../../../../stores/model/metamodel/fsm';
import type { IState } from '../../../../stores/model/metamodel/state';
import type { ITransition } from '../../../../stores/model/metamodel/transition';
import type { IAttribute } from '../../../../stores/model/metamodel/attribute';
import type { IMultiplePropagationConstraint } from '../../../../stores/model/metamodel/multiple_propagation_constraint';
import type { AttributeOwnerLike } from '../../types';

export function ADMC_Object(metamodel: IMetaModel, objectType: IObjectType): void {
  metamodel.removeObjectType(objectType.id);
}

export function ADMC_Attribute(owner: AttributeOwnerLike | null, attribute: IAttribute): void {
  // `attribute.owner` is typed as the erased MST node (IAnyStateTreeNode); at
  // runtime it is always a concrete attribute owner with removeAttribute.
  const o: AttributeOwnerLike = owner ? owner : (attribute.owner as unknown as AttributeOwnerLike);
  o.removeAttribute(attribute.id);
}

export function ADMC_Method(metamodel: IMetaModel, method: IMethod): void {
  metamodel.removeMethod(method.id);
}

export function ADMC_Dependency(metamodel: IMetaModel, dependency: IDependency): void {
  metamodel.removeDependency(dependency.id);
}

export function ADMC_Inheritance(metamodel: IMetaModel, inheritance: IInheritance): void {
  metamodel.removeInheritance(inheritance.id);
}

export function ADMC_Event(metamodel: IMetaModel, eventType: IEventType): void {
  metamodel.removeEventType(eventType.id);
}

export function ADMC_FSM(objectType: IObjectType, fsm: IFSM): void {
  objectType.removeFSM(fsm.id);
}

export function ADMC_State(fsm: IFSM, state: IState): void {
  fsm.removeState(state.id);
}

export function ADMC_Transition(fsm: IFSM, transition: ITransition): void {
  fsm.removeTransition(transition.id);
}

export function ADMC_MultiplePropagationConstraint(
  objectType: IObjectType,
  mpc: IMultiplePropagationConstraint
): void {
  objectType.removeMultiplePropagationConstraint(mpc.id);
}
